import type { IconName } from '@polyseme/design-system';

import { Icon } from '@polyseme/design-system';
import { cn } from '@polyseme/utils/cn/cn-utils';

type CategoryIconProps = {
  className?: string;
  icon: IconName;
};

export const CategoryIcon = ({ className, icon }: CategoryIconProps) => (
  <div
    className={cn(
      'flex max-h-max w-max max-w-max justify-center rounded-lg bg-gray-100 p-[10px] text-black transition-colors',
      className
    )}
  >
    <Icon className="size-8" name={icon} />
  </div>
);
